import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from '../../services/spinner.service';
import { PoseedorControllerService, ApiPoseedores, ProvinciaControllerService } from 'api-rest';
import { SnackbarService } from '../../services/snackbar.service';
import { ValidateService } from '../../services/validate.service';
import Swal from 'sweetalert2';

const ID_ESPANA = 69;

@Component({
  selector: 'managers-agreements-add-modal',
  templateUrl: './managers-agreements-add-modal.component.html',
  styleUrls: ['./managers-agreements-add-modal.component.scss']
})
export class ManagersAgreementsAddModalComponent implements OnInit {
  formGroup!: FormGroup;
  acuerdoIndirectoInfo!: any;

  paisesEndpoint = this.environment.urlBackCore + 'api/v1/core/countries';
  provinciasEndpoint = this.environment.urlBackCore + 'api/v1/core/provinces';
  cnaeEndpoint = this.environment.urlBackCore + 'api/v1/core/cnae';
  paisesSortValue = 'iso';
  private espana: any = null;
  private createdPoseedor: any = null;
  esShow: boolean = false;
  fiveDigitsPattern: string = '^[0-9]{1,5}$';
  selectProvince: any;
  provinceEs: any[] = [];
  actionExecuted: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ManagersAgreementsAddModalComponent>,
    private formBuilder: FormBuilder,
    public spinnerSrv: SpinnerService,
    private poseedorControllerSrv: PoseedorControllerService,
    private snackBarSrv: SnackbarService,
    private validateSrv: ValidateService,
    private provinciaControllerSrv: ProvinciaControllerService,
    @Inject('environment') private environment: any
  ) {
    this.formGroup = this.formBuilder.group({
      razonSocial: [{ value: null, disabled: false }, [Validators.required]],
      tipoDocumento: [{ value: 'NIF', disabled: false }, [Validators.required]],
      codigoDocumento: [
        { value: null, disabled: false },
        [Validators.required, Validators.pattern(this.validateSrv.nifPattern)],
      ],
      nima: [
        { value: null, disabled: false },
        [Validators.pattern(this.validateSrv.nimaPattern), Validators.maxLength(10)],
      ],
      denominacionCentro: [{ value: null, disabled: false }, [Validators.required]],
      cnae: [{ value: null, disabled: false }, [Validators.required]],
      nombre: [{ value: null, disabled: false }, [Validators.required, Validators.maxLength(50)]],
      apellido1: [{ value: null, disabled: false }, [Validators.required, Validators.maxLength(50)]],
      pais: [{ value: null, disabled: false }, [Validators.required]],
      codigoPostal: [{ value: null, disabled: false }, [Validators.maxLength(255)]],
      provincia: [{ value: null, disabled: false }, [Validators.maxLength(255)]],
      municipio: [{ value: null, disabled: false }, [Validators.maxLength(255)]],
      nombreVia: [{ value: null, disabled: false }, [Validators.maxLength(100)]],
      numero: [{ value: null, disabled: false }, [Validators.maxLength(5)]],
    });
    this.formGroup.get('tipoDocumento')?.valueChanges.subscribe((value: any) => {
      this.tipoDocumentoSel(value);
    });
  }

  ngOnInit(): void {
    this.acuerdoIndirectoInfo = this.data?.acuerdoIndirectoInfo;
    this.getProvinceByCp();
    this.cargarCP();
  }

  getProvinceByCp(): void {
    this.provinciaControllerSrv.listarComunidades1({}, { page: 0, size: 500, sort: [] }).subscribe({
      next: (data: any) => {
        this.provinceEs = data?.datos ?? [];
      },
      error: () => {},
    });
  }

  cargarCP(): void {
    this.formGroup.get('codigoPostal')?.valueChanges.subscribe((value: any) => {
      this.actionExecuted = false;
      this.formGroup.get('provincia')?.enable();
      if (
        value !== null &&
        !this.actionExecuted &&
        (this.formGroup.get('pais')?.value?.id == 69 || this.formGroup.get('pais')?.value == 'ESPAÑA')
      ) {
        const cpValue = value != null ? value.toString() : null;
        if (/^\d{5}$/.test(cpValue)) {
          const twoDigits = parseInt(cpValue.substring(0, 2), 10);
          const data = this.provinceEs.find((objeto: any) => objeto.id == twoDigits);
          if (data) {
            this.selectProvince = data;
            this.formGroup.get('provincia')?.setValue(this.selectProvince?.nombre);
            this.formGroup.get('provincia')?.disable();
          }
          this.actionExecuted = true;
        }
      }
    });
  }

  cerrar(): void {
    this.dialogRef.close(this.createdPoseedor ? { createdPoseedor: this.createdPoseedor } : undefined);
  }

  getCnaeDescription(cnae: any): string {
    return cnae?.clase + ' - ' + cnae?.descripcion;
  }

  getCnaeObjectQuery(searchterm: string) {
    return {
      descripcion: `or(ci(${searchterm}))`,
      clase: `or(ci(${searchterm}))`,
    };
  }

  tipoDocumentoSel(idTipoDoc: string): void {
    this.formGroup.get('codigoDocumento')?.clearValidators();
    if (idTipoDoc === 'NIF') {
      this.formGroup
        .get('codigoDocumento')
        ?.setValidators([Validators.required, Validators.pattern(this.validateSrv.nifPattern)]);
    } else if (idTipoDoc === 'DNI') {
      this.formGroup
        .get('codigoDocumento')
        ?.setValidators([Validators.required, Validators.pattern(this.validateSrv.dniPattern)]);
    } else if (idTipoDoc === 'NIE') {
      this.formGroup
        .get('codigoDocumento')
        ?.setValidators([Validators.required, Validators.pattern(this.validateSrv.niePattern)]);
    }
    this.formGroup.get('codigoDocumento')?.updateValueAndValidity();
    this.formGroup.get('codigoDocumento')?.markAsTouched();
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  controlHasErrorSelect(controlName: string): boolean {
    return !!(
      (this.formGroup.controls[controlName]?.touched || this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    );
  }

  public rightHolder(controlName: string): string {
    return this.controlHasErrorSelect(controlName) ? 'error-focus-input' : 'success-focus-input';
  }

  selectedModel(selectForm: string): void {
    if (selectForm === 'pais') {
      if (this.formGroup.controls['pais']?.value == null) {
        this.formGroup.controls['provincia']?.setValue(null);
        this.formGroup.controls['codigoPostal']?.setValue(null);
        this.formGroup.controls['municipio']?.setValue(null);
        this.formGroup.get('provincia')?.enable();
      }
      this.selectProvince = null;
    }
  }

  filterList(data: any, selectForm: string): void {
    if (selectForm === 'pais' && !this.espana) {
      const espana = (data ?? []).find((pais: any) => pais?.id === ID_ESPANA);
      if (espana) {
        this.espana = espana;
        // Se difiere para que ng-select ya haya renderizado las opciones
        setTimeout(() => this.seleccionarEspana());
      }
    }
  }

  private seleccionarEspana(): void {
    if (this.espana && !this.formGroup.get('pais')?.value) {
      this.formGroup.get('pais')?.setValue(this.espana);
    }
  }

  // Determina si el país seleccionado es España para exigir los campos de dirección obligatorios
  esES(): boolean {
    const pais = this.formGroup.get('pais')?.value;
    const esEs = pais === 'ESPAÑA' || pais?.iso === 'ES';
    this.esShow = esEs;

    if (esEs) {
      this.formGroup.get('nombreVia')?.setValidators([Validators.required, Validators.maxLength(100)]);
      this.formGroup.get('provincia')?.setValidators([Validators.required, Validators.maxLength(255)]);
      this.formGroup
        .get('codigoPostal')
        ?.setValidators([Validators.required, Validators.pattern(this.fiveDigitsPattern)]);
      this.formGroup.get('municipio')?.setValidators([Validators.required, Validators.maxLength(255)]);
      this.formGroup.get('numero')?.setValidators([Validators.required, Validators.maxLength(5)]);
    } else {
      this.formGroup.get('nombreVia')?.setValidators([Validators.maxLength(100)]);
      this.formGroup.get('provincia')?.setValidators([Validators.maxLength(255)]);
      this.formGroup.get('codigoPostal')?.setValidators([Validators.pattern(this.fiveDigitsPattern)]);
      this.formGroup.get('municipio')?.setValidators([Validators.maxLength(255)]);
      this.formGroup.get('numero')?.setValidators([Validators.maxLength(5)]);
    }
    this.formGroup.get('nombreVia')?.updateValueAndValidity({ onlySelf: true });
    this.formGroup.get('provincia')?.updateValueAndValidity({ onlySelf: true });
    this.formGroup.get('codigoPostal')?.updateValueAndValidity({ onlySelf: true });
    this.formGroup.get('municipio')?.updateValueAndValidity({ onlySelf: true });
    this.formGroup.get('numero')?.updateValueAndValidity({ onlySelf: true });
    return esEs;
  }

  getFormControl(controlName: string): FormControl {
    return this.formGroup.controls[controlName] as FormControl;
  }

  // Construye la direccion con el objeto completo de pais/provincia, tal como espera el backend
  private buildDireccionPayload(): any {
    const pais = this.formGroup.get('pais')?.value;
    const domicilio: any = { pais };

    const provincia = this.selectProvince ?? this.formGroup.get('provincia')?.value;
    const cp = this.formGroup.get('codigoPostal')?.value ? this.formGroup.get('codigoPostal')?.value.trim() : null;

    if (pais?.iso === 'ES') {
      domicilio.provincia = typeof provincia === 'string' ? { nombre: provincia } : provincia;
      domicilio.codigoPostal = { id: null, codigoPostal: cp };
    } else {
      domicilio.provincia = { nombre: provincia };
      domicilio.codigoPostal = { codigoPostal: cp };
    }

    domicilio.municipio = this.formGroup.get('municipio')?.value ? this.formGroup.get('municipio')?.value.trim() : null;
    domicilio.nombreVia = this.formGroup.get('nombreVia')?.value ? this.formGroup.get('nombreVia')?.value.trim() : null;
    domicilio.numero = this.formGroup.get('numero')?.value ? this.formGroup.get('numero')?.value.trim() : null;

    return domicilio;
  }

  guardar(): void {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      this.snackBarSrv.showSnackBar('Debe completar los campos obligatorios', 'error');
      return;
    }

    const cnae = this.formGroup.get('cnae')?.value;
    const payload: ApiPoseedores.PoseedorNoRegistradoPayloadDTO = {
      razonSocial: this.formGroup.get('razonSocial')?.value,
      tipoDocumento: this.formGroup.get('tipoDocumento')?.value,
      codigoDocumento: this.formGroup.get('codigoDocumento')?.value,
      denominacionCentro: this.formGroup.get('denominacionCentro')?.value,
      nima: this.formGroup.get('nima')?.value,
      cnae1: { clase: cnae?.clase, division: cnae?.division, grupo: cnae?.grupo },
      direccion: this.buildDireccionPayload(),
    };
    this.spinnerSrv.loadingShow();
    this.poseedorControllerSrv.createPoseedorNoRegistrado(payload).subscribe({
      next: (createdPoseedor: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Poseedor no registrado creado correctamente', 'success');
        this.createdPoseedor = createdPoseedor;
        this.preguntarNuevoCentro();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al crear el poseedor no registrado', 'error');
      },
    });
  }

  private preguntarNuevoCentro(): void {
    Swal.fire({
      text: '¿Desea continuar añadiendo nuevos centros asociados a este poseedor?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.reiniciarFormulario();
      } else {
        this.cerrar();
      }
    });
  }

  // Conserva tipo de documento, documento y razón social para dar de alta más centros del mismo poseedor
  private reiniciarFormulario(): void {
    const { tipoDocumento, codigoDocumento, razonSocial } = this.formGroup.getRawValue();
    this.formGroup.reset({ tipoDocumento, codigoDocumento, razonSocial });
    this.formGroup.get('provincia')?.enable();
    this.selectProvince = null;
    this.seleccionarEspana();
  }

}
